<div *ngIf="order">
    <app-create-order *ngIf="!order.id"></app-create-order>
    <div *ngIf="order.id">
        <!--
        <app-step-stones
            [stepStones]="orderSteps"
            [activeStepIndex]="orderService.currentStepIndex"
            [showStepStones]="true"
            [showStepStoneNavigation]="false"
            (shouldChangeStepIndex)="onChangeStep($event)"></app-step-stones>
        -->
        <div class="sticky-top" style="top: 70px; background: #fff;">
            <div style="margin-top: -31px; margin-bottom: 5px;">
                <button class="btn btn-sm btn-outline-secondary" style="padding: 0 5px;" (click)="toggleHeader()">
                    <fa-icon *ngIf="!headerCollapsed" [icon]="faChevronUp"></fa-icon>
                    <small *ngIf="!headerCollapsed">&nbsp;Skjul ordreinformation</small>

                    <fa-icon *ngIf="headerCollapsed" [icon]="faChevronDown"></fa-icon>
                    <small *ngIf="headerCollapsed">&nbsp;Vis ordreinformation</small>
                </button>
            </div>

            <div class="collapse  w-100" [class.show]="!headerCollapsed">
                <div class="row">
                    <div class="col-12  col-sm-6  col-xl-3  mb-4">
                        <div class="data-board">
                            <h5>Fakturaoplysninger</h5>
                            <hr class="mt-0">

                            <app-client-contact-info [order]="order"></app-client-contact-info>
                            <div class="my-2"></div>
                            <app-client-contact-meta [order]="order"></app-client-contact-meta>
                        </div>
                    </div>
                    <div class="col-12  col-sm-6  col-xl-3  mb-4">
                        <div class="data-board">
                            <h5>Leveringsoplysninger</h5>
                            <hr class="mt-0">

                            <table *ngIf="deliveryContact" class="table  table-borderless  table-sm  mb-0">
                                <ng-container *ngFor="let contactFieldSlug of ['project_name', 'project_number', 'address_1', 'zip', 'city']">
                                    <ng-container *ngIf="deliveryContact.getContactFieldObjectBySlug(contactFieldSlug) as contactField">
                                        <tr>
                                            <td>{{ contactField.name }}</td>
                                            <td>
                                                <input
                                                    [type]="contactField.type"
                                                    [id]="'contact-field-' + contactField.id"
                                                    class="form-control  form-control-sm"
                                                    [name]="contactField.slug"
                                                    [(ngModel)]="contactField._joinData.value"
                                                />
                                            </td>
                                        </tr>
                                    </ng-container>
                                </ng-container>
                            </table>
                        </div>
                    </div>
                    <div class="col-12  col-sm-6  col-xl-3  mb-4">
                        <div class="data-board">
                            <h5>Ordreoplysninger</h5>
                            <hr class="mt-0">
                            <app-dates-and-info [order]="order" [debtor]="debtor" [creditor]="creditor"></app-dates-and-info>
                        </div>
                    </div>
                    <div class="col-12  col-sm-6  col-xl-3  mb-4">
                        <div class="data-board">
                            <h5>Salgsoplysninger</h5>
                            <hr class="mt-0">
                            <app-total-prices [order]="order"></app-total-prices>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <router-outlet name="order_outlet"></router-outlet>
        <app-step-stones [canGoToNextStep]="true" [stepStones]="orderSteps" [activeStepIndex]="orderService.currentStepIndex" [showStepStones]="false" [showStepStoneNavigation]="true" (shouldChangeStepIndex)="onChangeStep($event)"></app-step-stones>
        -->

        <app-step-1-order-details></app-step-1-order-details>

        <div class=""></div>
        <app-step-2-order-overview></app-step-2-order-overview>

        <div class="my-3"></div>
        <app-step-3-order-delivery></app-step-3-order-delivery>

        <!--<button (click)="save()" class="btn  btn-primary  mt-2">Gem</button> @todo pull to the right?-->
    </div>
</div>
<app-loader *ngIf="!order"></app-loader>
